import React, { useContext, useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./App.css";

import Login from "./Components/Admin/Login/Login";
import Sidebar from "./Components/Admin/Sidebar/Sidebar";
import Header from "./Components/Admin/Header/Header";
import Order from "./Components/Admin/DashBoard/Order/Order";
import Country from "./Components/Admin/Masters/Country/Tables";
import State from "./Components/Admin/Masters/State/Tables";
import City from "./Components/Admin/Masters/City/Tables";
import Pincode from "./Components/Admin/Masters/Pincode/Tables";
import Occupation from "./Components/Admin/Masters/Occupation/Tables";
import FAQ from "./Components/Admin/Masters/Faq/Tables";
import FaqCategory from "./Components/Admin/Masters/FaqCategory/Tables";
import AppSetup from "./Components/Admin/Masters/App_setup/Tables";
import BankDetail from "./Components/Admin/Masters/BankDetail/Tables";
import Calendars from "./Components/Admin/Masters/Calendar/Tables";
import DashboardMain from "./Components/Admin/DashboardMain/DashboardMain/Tables";
import Investor from "./Components/Admin/Investor/Investor/Tables";
import EditInvestor from "./Components/Admin/Masters/Investor/Tables";
import Investorledger from "./Components/Admin/Investorledger/Investorledger/Tables";
import ReportList from "./Components/Admin/Reportlist/Tables";
import Investorprofitledger from "./Components/Admin/Investorprofitledger/Investorprofitledger/Tables";
import Inward from "./Components/Admin/Inward/Inward/Tables";
import BankPayment from "./Components/Admin/BankPayment/BankPayment/Tables";
import OutWard from "./Components/Admin/Outward/Outward/Tables";
import Canceled from "./Components/Admin/Canceled/Tables";
import BulkOutWard from "./Components/Admin/Outward/BulkOutWard/Tables";
import Chats from "./Components/Admin/Chats/Chats";
import Transfer from "./Components/Admin/Transfer/transfer/Tables";
import Notification from "./Components/Admin/Notification/Notification/Tables";
import Operation from "./Components/Admin/Operations/Operations/Tables";
import RateUs from "./Components/Admin/RateUs/RateUs/Tables";
import Pnl from "./Components/Admin/PnL/Pnl/Table";
import Pnlclient from "./Components/Admin/PnL/Pnl_client/Tables";
import PnlTransaction from "./Components/Admin/PnL/PnlTransaction/Tables";
import { Context } from "./utils/context";
import Employee from "./Components/Admin/Masters/Epmloyee/Tables";
import Strategy from "./Components/Admin/Masters/Strategy/Tables";
import Banner from "./Components/Admin/Masters/Banner/Tables";
import AboutBlueChart from "./Components/Admin/Information/AboutBlueChart/Tables";
import Licence from "./Components/Admin/Information/Licence/Tables";
import OurMissions from "./Components/Admin/Information/OurMissions/Tables";
import LiquidityProviders from "./Components/Admin/Information/LiquidityProviders/Tables";
import Awards from "./Components/Admin/Information/Awards/Tables";
import OurLocations from "./Components/Admin/Information/OurLocations/Tables";
import TermsAndCondition from "./Components/Admin/Information/TermsAndCondition/Tables";
import PrivacyPolicy from "./Components/Admin/Information/PrivacyPolicy/Tables";
import Network from "./Components/Admin/Masters/Network/Tables";
import Role from "./Components/Admin/Masters/Role/Table";

// Tickets Management
import Subjects from "./Components/Admin/TicketManagement/Subjects/Tables";

import Tickets from "./Components/Admin/TicketManagement/Tickets/Tables";

import PageNotFound from "../src/Components/Admin/PageNotFound/PageNotFound";
import { Permission } from "./utils/permissions";
library.add(fas);

const App = () => {
  const { signin, isAllow } = useContext(Context);
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen((prevOpen) => !prevOpen);
  };

  // On small screens the sidebar is an off-canvas drawer: start closed after
  // login and close again whenever the route changes.
  useEffect(() => {
    if (window.matchMedia("(max-width: 991.98px)").matches) {
      setSidebarOpen(false);
    }
  }, [location.pathname, signin]);

  const [urls, setUrls] = useState([]);
  useEffect(() => {
    setUrls([
      {
        path: "/",
        element: <Login />,
        status: true,
      },
      {
        path: "/Header",
        element: <Header />,
        status: true,
      },
      {
        path: "/dashboard",
        element: <DashboardMain />,
        status: isAllow?.includes(Permission.Dashboard.TotalRegistration.name),
      },
      {
        path: "/orders",
        element: <Order />,
        status: true,
      },
      {
        path: "/investor",
        element: <Investor />,
        status: isAllow?.includes(Permission.Investor.List.name),
      },
      {
        path: "/edit-investor",
        element: <EditInvestor />,
        status: isAllow?.includes(Permission.Investor.Edit.name),
      },
      {
        path: "/investor-ledger",
        element: <Investorledger />,
        status: isAllow?.includes(Permission.InvestorLedger.List.name),
      },
      {
        path: "/report-list",
        element: <ReportList />,
        status: isAllow?.includes(Permission.Reports.List.name),
      },
      {
        path: "/investor-profit-ledger",
        element: <Investorprofitledger />,
        status: isAllow?.includes(Permission.InvestorLedger.List.name),
      },
      {
        path: "/inward",
        element: <Inward />,
        status: isAllow?.includes(Permission.InwardPayment.InvestorList.name),
      },
      {
        path: "/bank-payments/:id",
        element: <BankPayment />,
        status: isAllow?.includes(Permission.InwardPayment.InvestorList.name),
      },
      {
        path: "/outward",
        element: <OutWard />,
        status: isAllow?.includes(Permission.OutwardPayment.UsersList.name),
      },
      {
        path: "/canceled",
        element: <Canceled />,
        status: isAllow?.includes(Permission.OutwardPayment.UsersList.name),
      },
      {
        path: "/bulk-outward",
        element: <BulkOutWard />,
        status: isAllow?.includes(Permission.OutwardPayment.UsersList.name),
      },
      {
        path: "/chats",
        element: <Chats />,
        status: isAllow?.includes(Permission.Chats.List.name),
      },
      {
        path: "/transfer",
        element: <Transfer />,
        status: isAllow?.includes(Permission.TransferPayment.List.name),
      },
      {
        path: "/notification",
        element: <Notification />,
        status: isAllow?.includes(Permission.Notification.List.name),
      },
      {
        path: "/rate-us",
        element: <RateUs />,
        status: isAllow?.includes(Permission.RateUs.List.name),
      },
      {
        path: "/pnl",
        element: <Pnl />,
        status: isAllow?.includes(Permission.PNLClientTransaction.List.name),
      },
      {
        path: "/pnl-client",
        element: <Pnlclient />,
        status: isAllow?.includes(Permission.PnlClient.List.name),
      },
      {
        path: "/pnl-transaction",
        element: <PnlTransaction />,
        status: isAllow?.includes(Permission.PnlTransaction.List.name),
      },
      {
        path: "/operations-main",
        element: <Operation />,
        status: isAllow?.includes(Permission.AppOperations.List.name),
      },

      {
        path: "/location/country",
        element: <Country />,
        status: isAllow?.includes(Permission.Country.List.name),
      },
      {
        path: "/location/state",
        element: <State />,
        status: isAllow?.includes(Permission.State.List.name),
      },
      {
        path: "/location/city",
        element: <City />,
        status: isAllow?.includes(Permission.City.List.name),
      },
      {
        path: "/masters/pincode",
        element: <Pincode />,
        status: true,
      },
      {
        path: "/masters/occupation",
        element: <Occupation />,
        status: true,
      },
      // {
      //   path: "/masters/banner",
      //   element: <Banner />,
      //   status: true,
      // },
      {
        path: "/masters/network",
        element: <Network />,
        status: isAllow?.includes(Permission.Network.List.name),
      },
      {
        path: "/masters/faq",
        element: <FAQ />,
        status: isAllow?.includes(Permission.FAQ.List.name),
      },
      {
        path: "/masters/faq-category",
        element: <FaqCategory />,
        status: isAllow?.includes(Permission.FAQ.List.name),
      },
      {
        path: "/masters/app-setup",
        element: <AppSetup />,
        status: isAllow?.includes(Permission.AppSetup.List.name),
      },
      {
        path: "/masters/bank-detail",
        element: <BankDetail />,
        status: isAllow?.includes(Permission.BankDetail.List.name),
      },
      {
        path: "/masters/calendar",
        element: <Calendars />,
        status: isAllow?.includes(Permission.Calendar.List.name),
      },
      {
        path: "/masters/employee",
        element: <Employee />,
        status: isAllow?.includes(Permission.Employee.List.name),
      },
      {
        path: "/masters/strategy",
        element: <Strategy />,
        status: isAllow?.includes(Permission.Strategy.List.name),
      },
      {
        path: "/masters/role",
        element: <Role />,
        status: isAllow?.includes(Permission.Role.List.name),
      },

      // Information

      {
        path: "/information/about-bluechart",
        element: <AboutBlueChart />,
        status: isAllow?.includes(Permission.AboutBlueChart.List.name),
      },
      {
        path: "/information/our-missions",
        element: <OurMissions />,
        status: isAllow?.includes(Permission.OurMissions.List.name),
      },
      {
        path: "/information/liquidity-providers",
        element: <LiquidityProviders />,
        status: isAllow?.includes(Permission.LiquidityProviders.List.name),
      },
      {
        path: "/information/awards",
        element: <Awards />,
        status: isAllow?.includes(Permission.Awards.List.name),
      },
      {
        path: "/information/our-locations",
        element: <OurLocations />,
        status: isAllow?.includes(Permission.OurLocations.List.name),
      },
      {
        path: "/information/licence",
        element: <Licence />,
        status: isAllow?.includes(Permission.Licence.List.name),
      },
      {
        path: "/information/terms-condition",
        element: <TermsAndCondition />,
        status: isAllow?.includes(Permission.TermsAndCondition.List.name),
      },
      {
        path: "/information/privacy-policy",
        element: <PrivacyPolicy />,
        status: isAllow?.includes(Permission.PrivacyPolicy.List.name),
      },

      // Ticket Management

      {
        path: "/ticket-management/subjects",
        element: <Subjects />,
        status: isAllow?.includes(Permission.Subject.List.name),
      },
      {
        path: "/ticket-management/tickets",
        element: <Tickets />,
        status: isAllow?.includes(Permission.Tickets.List.name),
      },
    ]);
  }, [isAllow]);

  return (
    <div className="top_section">
      {signin && (
        <>
          <header className="sub-header">
            <div className="main-sub-header">
              <button
                type="button"
                className="sidebar-toggle"
                onClick={toggleSidebar}
                aria-label={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
                aria-expanded={sidebarOpen}
              >
                <FaBars />
              </button>
              <h3 className="Itlogtitle">
                <span className="brand-mark" aria-hidden="true">
                  B
                </span>
                <span className="brand-name">BlueChart</span>
                <span className="brand-tag">ADMIN</span>
              </h3>
            </div>
            <div className="admin-header">
              <div className="user">
                <FontAwesomeIcon icon={["fas", "user"]} className="user-icon" />
              </div>
              <div className="text">
                <p>BlueChart/Admin</p>
              </div>
            </div>
          </header>

          <div
            className={`app-shell ${
              sidebarOpen ? "is-sidebar-open" : "is-sidebar-collapsed"
            }`}
          >
            <div className="app-sidebar">
              <Sidebar isOpen={sidebarOpen} />
            </div>
            <div
              className="app-backdrop"
              onClick={toggleSidebar}
              aria-hidden="true"
            />
            <main className="app-content">
              <Routes>
                {urls?.map(
                  (url) =>
                    url.status && (
                      <Route
                        key={url.path}
                        path={url.path}
                        element={url.element}
                      />
                    ),
                )}
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </main>
          </div>
        </>
      )}

      {!signin && <Login />}
    </div>
  );
};

export default App;
